<template>
    <div>
        <div class="d-flex w-100" v-for="gridRow in gridRows">
            <div v-for="(document, index) in gridRow" class="mb-3" :class="dynamicClasses">
                <router-link :to="detailsRoute(document['id'])" class="no-underline">

                    <!-- Render a custom view -->
                    <div v-if="view.layout && view.layout.rows" class="card shadow-sm h-100 mb-1"
                         style="border-radius: 10px !important;"
                         :class="cardMarginClasses(index)">

                        <img v-if="featuredImageField && getFeaturedImage(document)"
                             :src="getFeaturedImage(document)" class="card-img-top">

                        <div class="card-body">
                            <div v-for="(row, index) in view.layout.rows">
                                <row-renderer v-if="featuredImageField && index > 0 || !featuredImageField"
                                              :layout="view.layout" :key="index + view.id + viewConfig.columnCount + 'row'"
                                              :row="row" :index="index" :document="document" :table="table"
                                              :view="view"></row-renderer>
                            </div>
                        </div>

                    </div>

                    <div v-else class="card shadow-sm h-100">

                        <img v-if="attachment && getFeaturedImage(document)" :src="getFeaturedImage(document)"
                             class="card-img-top">

                        <div class="card-body">
                            <h5 class="card-title">
                                {{fieldValue(document, primaryField)}}
                            </h5>

                            <select-view v-if="selectField" :document="document"
                                         :field="selectField"></select-view>

                            <p v-if="textField" v-html="fieldValue(document, textField)" class="card-text"></p>
                        </div>
                    </div>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import ViewService from "../../services/ViewService";

    export default {
        name: 'GalleryGridRenderer',
        props: {
            view: Object,
            table: Object,
            layout: Object,
            viewModel: Object,
            parentTable: Object,
            parentDocument: Object,
            viewConfig: Object
        },
        computed: {
            dynamicClasses() {
                if (this.viewConfig.columnCount === 1) {
                    return 'w-100'
                } else if (this.viewConfig.columnCount === 2) {
                    return 'w-50'
                } else if (this.viewConfig.columnCount === 3) {
                    return 'w-33'
                }

                return 'w-25'
            },
            primaryField() {
                return webase.utils.table.getPrimaryField(this.table)
            },
            gridRows() {
                return webase.utils.array.listToGrid(this.records, this.viewConfig.columnCount)
            },
            attachment() {
                let field = webase.utils.table.getAttachmentField(this.table)
                return field
            },
            textField() {
                return webase.utils.table.getTextField(this.table)
            },
            selectField() {
                return webase.utils.table.getSelectField(this.table)
            }
        },
        data() {
            return {
                model: webase.model,
                records: [],
                featuredImageField: null
            }
        },
        mounted() {
            this.loadData()
            webase.eventDispatcher.on('viewUpdated', this.loadData)
            this.setFeaturedImage()
        },
        beforeUnmount() {
            webase.eventDispatcher.off('viewUpdated', this.loadData)
        },
        methods: {
            // gridRows(columnCount) {
            //     return webase.utils.array.listToGrid(this.records, columnCount)
            // },
            loadData() {
                let viewService = new ViewService()

                viewService.getData(this.view, this.table).then((response) => {
                    this.records = response
                }).catch((message) => {
                    console.log('error loading data from table')
                    console.log(message)
                })
            },
            fieldValue(document, field) {
                return document[field.index]
            },
            getFeaturedImage(record) {

                if (this.featuredImageField) {
                    let imageData = record[this.featuredImageField.index]

                    if (imageData) {
                        return imageData.url
                    }
                }


                let attachmentData = record[this.attachment.index]

                if (attachmentData === undefined || attachmentData === null || attachmentData.length === 0) {
                    return null
                }

                let firstAttachment = attachmentData[0]

                if (!webase.utils.table.isImage(firstAttachment)) {
                    return null
                }

                let featureImageUrl = firstAttachment.url
                // console.log(featureImageUrl)
                return featureImageUrl
            },
            detailsRoute(documentId) {

                if (webase.utils.table.hasDetailsView(this.table)) {
                    let detailsView = webase.utils.table.getDetailsView(this.table)
                    return {name: 'details-view', params: {view_id: detailsView.id, record_id: documentId}}
                }

                return {name: 'static-details', params: {table_id: this.table.id, record_id: documentId}}
            },
            setFeaturedImage() {
                if (this.view.layout.rows && this.view.layout.rows.length > 0) {
                    let firstRow = this.view.layout.rows[0]

                    if (firstRow.columns && firstRow.columns.length > 0) {
                        let firstColumn = firstRow.columns[0]

                        console.log(firstColumn)

                        if (firstColumn.value && firstColumn.value.length > 0) {
                            let firstComponent = firstColumn.value[0]

                            if (firstComponent.type === 'Field' && firstComponent.value.field_type === 'Image') {
                                this.featuredImageField = firstComponent.value
                                return
                            }
                        }
                    }
                }
            },

            cardMarginClasses(index) {
                if(this.viewConfig.columnCount === 1) {
                    return ''
                }

                if(index === 0) {
                    return 'me-1'
                }
                else if(index === 1 && this.viewConfig.columnCount === 2) {
                    return 'ms-1'
                }
                else if(index === 1 && this.viewConfig.columnCount === 3) {
                    return 'mx-1'
                }
                else if(index === 2 && this.viewConfig.columnCount === 3) {
                    return 'ms-1'
                }
                else if(index === 2 && this.viewConfig.columnCount === 3) {
                    return 'mx-1'
                }
                else if(index === 3 && this.viewConfig.columnCount === 4) {
                    return 'ms-1'
                }

            }
        }
    }
</script>

<style>

</style>
